import { BottomSheet } from '../bottomSheet'
import DatePicker from '../datePicker'
import { Stack } from '../layout'

interface IDatePicker {
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>
  setStartDate: React.Dispatch<React.SetStateAction<string>>
  setEndDate: React.Dispatch<React.SetStateAction<string>>
  startDate: string
  endDate: string
  today: string
  isModalVisible: boolean
}
const DateRangePicker = ({
  setIsModalVisible,
  isModalVisible,
  startDate,
  setEndDate,
  endDate,
  setStartDate,
  ...props
}: IDatePicker) => {
  return (
    <>
      <BottomSheet
        visible={isModalVisible}
        onDismiss={() => setIsModalVisible(false)}
        disableBottomSheet={() => setIsModalVisible(false)}
      >
        <Stack className="items-center justify-center">
          <DatePicker
            setIsVisible={setIsModalVisible}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            startDate={startDate}
            endDate={endDate}
            isModalVisible={false}
            {...props}
          />
        </Stack>
      </BottomSheet>
    </>
  )
}
export default DateRangePicker
